const config = {
    audio: {
        smoothing: 0.8,
        fftWindowSize: 1024
    },
    visualiser: {
        fadeOutIntervalMillis: 2000,
        oscillograph: {
            bucketCount: 20,
            waveSpeed: 0.5,
            minWaveLightness: 10
        },
        phonograph: {
            bucketCount: 100,
            bucketSpread: 1.2,
            minRadius: 30,
            silenceThresholdMillis: 5000,
            gapTotal: Math.PI,
            offsetRate: 0.00001,
            snapshotIntervalMillis: 1000,
            gradientStartColour: 10,
            gradientStopColour: 255,
            snapshotStartColour: 100,
            snapshotStopColour: 0,
            snapshotSpeed: 1,
            snapshotFadeOutFactor: 2
        },
        spirograph: {
            bucketCount: 100,
            bucketSpread: 1.5,
            silenceThresholdMillis: 5000,
            rotationBaseValue: 0.0005,
            alphaCycleRate: 600,
            aspectRatio: 0.5,
            rotationFactor: 1 / 3,
            maxRadiusSize: 0.5,
            minRadiusSize: 0.25,
            historySize: 10,
            backgroundLoop: {
                minRadiusFactor: 0.5,
                maxRadiusFactor: 2,
                minAlpha: 0.05,
                maxAlpha: 0.15,
                offset: 0
            },
            foregroundLoop: {
                minAlpha: 0.1,
                maxAlpha: 0.4,
                offset: 0.5
            }
        }
    },
    sleepTimer: {
        fadeOutDelta: 0.02,
        fadeOutIntervalMillis: 100,
        intervals: [
            90,
            60,
            45,
            30,
            15
        ]
    },
    schedule: {
        refreshIntervalMillis: 5000,
        lengthInSeconds: 43200
    },
    messages: {
        canned: {
            "all": [
                'All audio hosted by The Internet Archive. Find more at http://archive.org',
                'Streaming shows from the Golden Age of Radio, 24 hours a day',
                "Volume too loud? You can turn it down, click the menu \u2197",
                'Please support The Internet Archive by donating at http://archive.org/donate',
                "Build your own channel with your favourite shows, click the menu \u2197",
                "To change the visualiser or turn it off, click the menu \u2197"
            ],
            "normal": [
                "To check the channel schedules, click the menu \u2197"
            ],
            "userChannel": [
                "To check the channel schedules, click the menu \u2197"
            ],
            "singleShow": [
                'There are many other classic shows playing at https://www.rumseyretro.ca/',
                "To check the channel schedule, click the menu \u2197"
            ]
        },
        charPrintIntervalMillis: 40,
        tempMessageDurationMillis: 5000,
        tempMessageIntervalMillis: 60000
    }
}; /*
MIT License

Copyright (c) 2020 Rob Dawson

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
 */ 

//# sourceMappingURL=public.8a48316b.js.map
